import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ConfigService } from '../../../services/config.service';
import { AuthService } from '../../../services/auth.service';
import { GmailService } from '../../../services/gmail.service';
import { O365Service } from '../../../services/o365.service';
import { ErrorService } from '../../../services/error.service';
import { GlobalMessageService } from '../../../services/global-message.service';
import { DriftService } from '../../../services/drift.service';

@Component({
  selector: 'app-inboxes-auth',
  templateUrl: './inboxes-auth.component.html'
})
export class InboxesAuthComponent implements OnInit {

  @ViewChild('invalidGoogleDialog') invalidGoogleDialog: TemplateRef<any>;
  @ViewChild('duplicateGoogleDialog') duplicateGoogleDialog: TemplateRef<any>;
  @ViewChild('duplicateO365Dialog') duplicateO365Dialog: TemplateRef<any>;
  @ViewChild('cancelledGoogleDialog') cancelledGoogleDialog: TemplateRef<any>;

  type: string = '';
  googleEmailAddress: string = '';
  loadingMessage: string = '';

  invalidGoogleDialogRef: BsModalRef;
  duplicateGoogleDialogRef: BsModalRef;
  duplicateO365DialogRef: BsModalRef;
  cancelledGoogleDialogRef: BsModalRef;

  constructor(private route: ActivatedRoute,
  						private router: Router,
              private authService: AuthService,
              private gmailService: GmailService,
              private o365Service: O365Service,
              private configService: ConfigService,
              private errorService: ErrorService,
              private driftService: DriftService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.type = this.route.snapshot.params['id'];
    let redirect = this.route.snapshot.queryParams['red'];

    if (redirect) {
      this.configService.gmailConfig().subscribe(
        (gmailConfig: any) => {
          let state = encodeURIComponent(`{"email":"${redirect}"}`);
          var url = `${gmailConfig.authUrl}?` +
              `response_type=code&prompt=consent&access_type=offline&` +
              `client_id=${gmailConfig.clientId}&` +
              `redirect_uri=${gmailConfig.redirectUrl}&` +
              `scope=${gmailConfig.scopes}&state=${state}`;

          window.location.href = url;
        },
        error => {

        }
      )
    }
    else {
      if (this.type == 'gmail') {
        this.handleGmailAuth();
      }
      else if (this.type=='o365') {
        this.handleO365Auth();
      }
    }
  }

  private handleGmailAuth() {
    var cancelled = this.route.snapshot.queryParams['error'];
    if (!cancelled) {
      var code = this.route.snapshot.queryParams['code'];
      var state = this.route.snapshot.queryParams['state'];
      if (!code || !state) {
        // TODO: something?
      }
      else {
        // state will contain the email address of the person authenticating
        var stateObj: any = JSON.parse(decodeURIComponent(state));
        let direct: boolean = stateObj.email=='direct';

        if (direct) {
          this.loadingMessage = 'Saving credentials...';
        }
        else {
          this.loadingMessage = 'Logging you into Drift Email...';
        }

        this.gmailService.grantAccess(code, stateObj.email).subscribe(
          (result: any) => {
            this.driftService.track('added-inbox', {type: 'gmail'});
            if (direct) {
              this.router.navigate(['settings/inboxes']);
              this.globalMessageService.message('Inbox added successfully');
            }
            else {
              // we send back the auth token from the back-end request so we can automatically log them into the app
              this.authService.loginGoogle(stateObj.email, result.token).subscribe(
                (result: any) => {
                  this.driftService.identify();
                  this.driftService.track('logged-in', { type:'google' });
                },
                err => {
                  // Invalid user
                  if (err.status == 404) {
                    this.googleEmailAddress = stateObj.email;
                    this.invalidGoogleDialogRef = this.modalService.show(this.invalidGoogleDialog);
                    this.router.navigate(['logout']);
                  }
                  else {
                    // some other server error, needs to be logged
                    this.globalMessageService.error();
                    this.errorService.log(err, 'inboxes-auth.component', 'onSubmit');
                  }
                }
              )
            }
          },
          error => {
            // Invalid user
            if (error.status == 404) {
              if (direct) {
                this.duplicateGoogleDialogRef = this.modalService.show(this.duplicateGoogleDialog);
                this.router.navigate(['settings/inboxes']);
              }
              else {
                this.googleEmailAddress = stateObj.email;
                this.invalidGoogleDialogRef = this.modalService.show(this.invalidGoogleDialog);
                this.router.navigate(['logout']);
              }
            }
            else {
              // some other server error, needs to be logged
              this.globalMessageService.error();
              this.errorService.log(error, 'inboxes-auth.component', 'onSubmit');
            }
          }
        )
      }
    }
    else {
      // cancelled operation
      this.cancelledGoogleDialogRef = this.modalService.show(this.cancelledGoogleDialog);
      this.modalService.onHide.subscribe(
        () => {
          this.router.navigate(['settings/inboxes']);
        }
      );
    }
  }

  private handleO365Auth() {
    var cancelled = this.route.snapshot.queryParams['error'];
    if (!cancelled) {
      var code = this.route.snapshot.queryParams['code'];
      var state = this.route.snapshot.queryParams['state'];
      if (!code || !state) {
        // TODO: something?
      }
      else {
        // state will contain the email address of the person authenticating
        this.driftService.track('added-inbox', {type: 'o365'});
        var stateObj: any = JSON.parse(decodeURIComponent(state));
        let direct: boolean = stateObj.email=='direct';

        if (direct) {
          this.loadingMessage = 'Saving credentials...';
        }
        else {
          this.loadingMessage = 'Logging you into Drift Email...';
        }

        this.o365Service.grantAccess(code, stateObj.email).subscribe(
          (result: any) => {
            if (direct) {
              this.router.navigate(['settings/inboxes']);
              this.globalMessageService.message('Inbox added successfully');
            }
            else {
              // we send back the auth token from the back-end request so we can automatically log them into the app
              // this.authService.loginGoogle(stateObj.email, result.token).subscribe(
              //   (result: any) => {
              //     this.intercomService.boot();
              //     this.driftService.track('logged-in');
              //     this.router.navigate(['']);
              //   },
              //   err => {
              //     // Invalid user
              //     if (err.status == 404) {
              //       this.googleEmailAddress = stateObj.email;
              //       this.modalService.open(this.invalidGoogleDialog).result.then((result: any) => {
              //         this.router.navigate(['logout']);
              //       }, () => { this.router.navigate(['logout']); });
              //     }
              //     else {
              //       // some other server error, needs to be logged
              //       this.globalMessageService.error();
              //       this.errorService.log(err, 'inboxes-auth.component', 'onSubmit');
              //     }
              //   }
              // )
            }
          },
          error => {
            // Invalid user
            if (error.status == 404) {
              if (direct) {
                this.duplicateO365DialogRef = this.modalService.show(this.duplicateO365Dialog);
                this.router.navigate(['settings/inboxes']);
              }
              else {
                // currently O365 is only direct (no invites)
              }
            }
            else {
              // some other server error, needs to be logged
              this.globalMessageService.error();
              this.errorService.log(error, 'inboxes-auth.component', 'onSubmit');
            }
          }
        )
      }
    }
    else {
      // Do-nothing: o365 doesn't have cancel option
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-inboxes/inboxes-auth/inboxes-auth.component.ts